export const PublicUrl = {
  DOCS_FIRST_REQUEST: `${import.meta.env.VITE_DOCS_URL}/documentation/first-request`,
  DOCS_FAQS: `${import.meta.env.VITE_DOCS_URL}/support-main#faqs`,
  TERMS_AND_CONDITIONS: `${import.meta.env.VITE_DOCS_URL}/terms_and_conditions`,
  PRIVACY_POLICY: `https://www.rpiprint.com/compliance`,
};

export const InternalUrl = {
  PDF_PROCESSING_URL: `${import.meta.env.VITE_PDF_PROCESSING_INTERNAL_URL}`,
};

export const PublicEmail = {
  SUPPORT: import.meta.env.VITE_SUPPORT_EMAIL,
};
